var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLine01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.517 140.074 16 16",
    enableBackground: "new 78.517 140.074 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M79.517,141.074h3v7h-1v1h3v-1h-1v-7h3v1h1v-2h-9v2h1V141.074z M78.517,151.074v1h16v-1H78.517z  M78.517,156.074h12v-1h-12V156.074z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLine01);
export default __webpack_public_path__ + "static/media/icon_line-01.075fe8d022a0bd7f13a4f214f8662653.svg";
export { ForwardRef as ReactComponent };